<template>
    <div v-if="$store.state.user.permissions.indexOf('tags-manage') >= 0">
        <Header></Header>
        
        <div class="main-inner">
            <div class="tabs-primary-header">
                <p class="d-flex mb-0">
<!--                    <span class="mr-4">Who can add tags:</span>-->

<!--                    <span class="input-radio input-radio&#45;&#45;big mr-4">-->
<!--                        <input type="radio" id="at1" name="at">-->
<!--                        <label for="at1">Everyone</label>-->
<!--                    </span>-->
<!--                    <span class="input-radio input-radio&#45;&#45;big">-->
<!--                        <input type="radio" id="at2" name="at">-->
<!--                        <label for="at2">Admins Only</label>-->
<!--                    </span>-->
                </p>
                <button @click="addTag" class="button">+ New Tag</button>
            </div>

            <table class="main-table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Added Startups</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="tag in tags" :key="tag.id">
                    <td>
                        <template v-if="tag.child">
                            <span class="nested-tag"></span>
                        </template>
                        <span class="text-ellipsis">{{tag.name}}</span>
                    </td>
                    <td>
                        {{tag.description}}
                    </td>
                    <td>
                        {{tag.added_startups}}
                    </td>
                    <td>
                        <div class="d-flex align-items-center text-nowrap">
                            <div>
                                <a @click="editTag(tag.id)" class="link-edit link-edit--secondary">Edit</a>
                            </div>
                            <div>
                                <a @click="deleteTag(tag.id)" class="link-delete link-delete--icon ml-4"><font-awesome-icon :icon="['fa', 'trash']" />Delete</a>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <TagEdit
                ref="editTag"
                v-on:tagSaved="getList"
            >
            </TagEdit>
        </div>
    </div>
</template>

<script>
import Header from "@/components/settings/Header"
import tags from "@/services/tags.service"
import TagEdit from "@/components/tags/EditTag"

export default {

    data() {
        return {
            tags: [],
        }
    },

    components: {
        Header,
        TagEdit
    },

    mounted() {
        this.getList()
    },

    methods: {
        getList() {
            tags.getTagsIndex().then(response => {
                this.tags = response.data
            })
        },

        editTag(id) {
            this.$refs.editTag.open(id)
        },

        deleteTag(id) {
            if (confirm("Remove tag?")) {
                tags.delete(id).then(() => {
                    this.getList()
                })
            }
        },

        addTag() {
            this.$refs.editTag.open(0)
        }
    }
}
</script>

<style scoped>

</style>